import { render, staticRenderFns } from "./BaseBatchList.vue?vue&type=template&id=7973a14c&scoped=true&"
import script from "./BaseBatchList.vue?vue&type=script&lang=js&"
export * from "./BaseBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973a14c",
  null
  
)

export default component.exports